import { render } from "./Debts.vue?vue&type=template&id=93dab2b2&scoped=true"
import script from "./Debts.vue?vue&type=script&lang=js"
export * from "./Debts.vue?vue&type=script&lang=js"

import "./Debts.vue?vue&type=style&index=0&id=93dab2b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93dab2b2"]])

export default __exports__